import {useState} from 'react';
import {Cookies} from "react-cookie"
import {Gestion} from "./Gestion"
import {Devoirs} from "./Devoirs"
import {Devoirs_alea} from "./Devoirs_alea"
import {Creer} from "./Creer0"
import {Mesquestions0} from "./Mesquestions0"
import {QuestionSignal} from "./QuestionSignal"
import {Erreurs} from "./Erreurs"
import {ErreursEleve} from "./ErreursEleve"
import {BonnesPratiques} from "./BonnesPratiques"
import {Classe} from "./Classe"
import {Chargement} from "./Chargement"
import {Devoirs_eleve} from "./Devoirs_eleve"
import {Essais_eleve} from "./Essais_eleve"
import {Stats_eleve} from "./Stats_eleve"
import './Onglet.css';


export function Onglet ({user, onglet, classe, setUser, setMenu}) {
	
	let contain = ''
	const [msg, setMsg] = useState('')
  	const cook = new Cookies();
	const [auth, setAuth] = useState({    
		nom:cook.get("nom"),
		prenom:cook.get("prenom"),
		mdp:cook.get("mdp"),
	})

	const updateUser = (param = '') => {
			if(param === 'eleve'){
				setMenu(['Mes devoirs', 'Mes essais', 'Mes stats'])
				setMsg('Votre note a bien été sauvegardée !')
				setTimeout(e => {
		          setMsg('')
		        }, 3000)
			}
			
		fetch("https://maths-au-quotidien.fr/react-automaths/api.php", {
			method: 'POST',
			body: JSON.stringify(auth)
		})
		.then(response => response.json())
		.then(data => {
			setUser(data)
			if('creer_groupe__suppr_groupe'.includes(param)){setMenu(['Gestion', 'Questions'].concat(data.liste_classes))}
		})
		.catch(err => console.log(err))
	}

	const update = (param) => {
		if(param === 'user' || param === 'eleve') {
			updateUser(param)
		} else {
			setAuth({...auth, ...param})
		}
	}

	const affiche_devoir = (onglet, user, auth, updateUser, setUser, classe) => {
		if (onglet === 'Gestion'){
			return <Gestion user={user} updateUser={updateUser} />
		} 
		if (onglet === 'Questions'){
			return <Devoirs user={user} auth={auth} updateUser={updateUser} />
		} 
		if (onglet === 'Donner'){
			return <Devoirs_alea user={user} auth={auth} updateUser={updateUser} />
		} 
		if (onglet === 'Créer'){
			return <Creer auth={auth} liste_activites_all={user.liste_activites_all}/>
		} 
		if (onglet === 'Mes séries'){
			return <Mesquestions0 auth={{...auth, id:user.id, niveaux:Object.keys(user.liste_activites_all), classes:Object.keys(user.mes_classes)}}/>
		}
		if (onglet === 'Retrouver'){
			return <QuestionSignal auth={{...auth, id:user.id}} />
		}
		if (onglet === 'Les erreurs'){
			return <Erreurs auth={{...auth, mes_classes:user.mes_classes, activite_faites:user.activite_faites}} />
		}  else {
			return <Classe setUser={setUser} classe={classe} updateUser={updateUser} />
		}
	}

	const affiche_devoir_eleve = (auth, setAuth, user, updateUser) => {
		if (onglet === 'Mes essais'){
			return <Essais_eleve auth={auth} user={user} updateUser={updateUser} />
		} 
		if (onglet === 'Mes stats'){
			return <Stats_eleve auth={auth} user={user} updateUser={updateUser} />
		} 
		if (onglet === 'Mes erreurs'){
			return <ErreursEleve auth={{...auth, activites:user.activites}} />
		} 
		if (onglet === 'Utilisation'){
			return <BonnesPratiques auth={{...auth, activites:user.activites}} />
		} 
		return <Devoirs_eleve auth={auth} setAuth={setAuth} />
	}
	
	if (user.profil === 'Professeur') {
		contain = <ul className="onglet_content">	
					<li>
						{affiche_devoir(onglet, user, auth, updateUser, setUser, classe)}
				    </li>
				    	
				</ul>
	} else if (user.profil === 'eleve' || user.profil === 'Autre') {
		contain = <>
					<h1 className="titre_compte">Bonjour {user.prenom}</h1>
					<h1 className="titre_compte titre_compte_classe">{user.classe && '('+user.classe+')'}</h1>

					<ul className="onglet_content">
						<li>
						{user.nb_zero && <div className="alert danger" style={{width:"500px"}}><br/>Attention {user.prenom},<br/> Vous avez obtenu {user.nb_zero} zéro{user.nb_zero > 1 ? 's' : ''} dans vos activités réalisées.<br/><br/></div>}
						{msg ? <div className={'alert success fadeout3'} dangerouslySetInnerHTML={{ __html:'<br>'+msg+'<br><br>'}}></div> : ''}
					    	{affiche_devoir_eleve(auth, setAuth, user, updateUser)}
						</li>
					</ul>
				</>
	} else {
		contain = <Chargement />
	}
	return contain
}